import tw from "twin.macro";

export const SectionHeading = tw.h2`text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-4xl font-black tracking-wide text-center`;
export const Subheading = tw.h5`font-bold text-primary-500`;
